import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, map } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "primeng/api";
import * as i2 from "../snackbar";
export class BannerService {
  messageService;
  snackbarService;
  _messages$ = new BehaviorSubject([]);
  messages$ = this._messages$.asObservable();
  key = 0;
  constructor(messageService, snackbarService) {
    this.messageService = messageService;
    this.snackbarService = snackbarService;
    this.messageService.messageObserver.pipe(filter(message => !this.containsSnackbarMessage(message)), map(message => this._messages$.next(this.toGeaMessage(message)))).subscribe();
    this.messageService.clearObserver.subscribe(key => {
      if (key === null) {
        this._messages$.next([]);
      } else {
        this._messages$.next(this.removeByKey(key));
      }
    });
  }
  add(message) {
    const messages = this._messages$.getValue();
    return this.messageService.addAll([...messages, message]);
  }
  /**
   * primeng's clear method doesn't work with keys -> workaround.
   * @param key
   */
  clear(key) {
    const messages = this._messages$.getValue().filter(message => message.key !== key);
    this.messageService.clear(key);
    if (messages.length) {
      this.messageService.addAll([...messages]);
    }
  }
  toGeaMessage(msg) {
    let messages = [];
    // eslint-disable-next-line no-prototype-builtins
    if (msg.hasOwnProperty('length')) {
      messages = msg;
    } else {
      messages = [msg];
    }
    messages.forEach(message => {
      if (!message.key && message.key !== this.snackbarService.key) {
        message.key = `${++this.key}`;
      }
    });
    return messages;
  }
  removeByKey(key) {
    return this._messages$.getValue().filter(message => message.key !== key);
  }
  containsSnackbarMessage(message) {
    if (Object.prototype.hasOwnProperty.call(message, 'length')) {
      const messages = message;
      messages.some(msg => msg.key === this.snackbarService.key);
    }
    return message.key === this.snackbarService.key;
  }
  static ɵfac = function BannerService_Factory(t) {
    return new (t || BannerService)(i0.ɵɵinject(i1.MessageService), i0.ɵɵinject(i2.SnackbarService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BannerService,
    factory: BannerService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BannerService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.MessageService
  }, {
    type: i2.SnackbarService
  }], null);
})();
